import { observer } from "mobx-react";
import React from "react";
import styled from "styled-components";
import { device } from "../../../WSUtils/constants/mediaQueries";
import { withWSErrorContainer } from "../../../WSUtils/withWSErrorContainer";
import {
  CVPSearchParams,
  queryStringStore,
} from "../../../WSUtils/wsQueryStringStore";
import Message from "./Message";
import MessageButtons from "./MessageButtons";
import { MessageInfo } from "./MessageInfo";

const MessageContent: React.FC = withWSErrorContainer(
  observer(({}) => {
    const messageId = queryStringStore.qs[CVPSearchParams.cvpmsgid];

    return (
      <StyledMessageContent className="cpv-message-content flex flex-column gap-5">
        <pre>{`Message id: ${messageId}`}</pre>
        <div>
          <MessageInfo />
        </div>
        <div className="flex-grow-1 mb-5">
          <Message />
        </div>

        <div className="flex justify-content-end">
          <MessageButtons />
        </div>
      </StyledMessageContent>
    );
  })
);
export default MessageContent;

export const StyledMessageContent = styled.div`
  &.cpv-message-content {
    border: 2px solid var(--primary-200);
    border-radius: 6px;
    margin-top: 5rem;
    padding: 1rem;
    align-self: stretch;

    @media ${device.lg} {
      padding: 2rem;
    }
  }
`;
